import script from "./TariffsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./TariffsBlock.vue?vue&type=script&setup=true&lang=js"

import "./TariffsBlock.vue?vue&type=style&index=0&id=fadd6e90&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fadd6e90"]])

export default __exports__